import React from 'react'
import { useSelector } from 'react-redux'
import { ObjectionDetail } from './components'
import { STAGE } from './constants'

export function ObjectionDrawer() {
  const { stage } = useSelector(({ drawer }) => drawer)

  return stages()[stage]
}

function stages() {
  return {
    [STAGE.INITIAL]: <ObjectionDetail />,
  }
}
